// 将不同的业务模块导出
import autoweb from "./autoweb"; // 自助建站
import clue from "./clue"; // 线索

import article from "./article"; // 文章
import poster from "./poster"; // 海报
import questionnaire from './questionnaire'; //问卷调查
import data from "./data";
import email from "./email"; // 邮件
import weixin from "./weixin"; // 微信
import video from "./video"; // 视频
import client from "./client";
import product from "./product";
import cases from "./case";
import solution from "./solution";
import website from './website' // 网站
import form from './form' // 网站

export default [
  autoweb,
  clue,
  article,
  poster,
  questionnaire,
  email,
  weixin,
  data,
  video,
  client,
  product,
  cases,
  solution,
  website,
  form
];
